(function () {
  const moveCancelButtonToTopActions = (cancelButton) => {
    console.log(cancelButton);
    let container;
    if (window.innerWidth > 768) {
      container = document.querySelector(
        ".bundle-action-col-layout .bundle-action-button-container"
      );
    } else {
      container = document.querySelector(".bundle-action-button-container");
    }
    if (container && cancelButton) {
      // Move the button instead of cloning to preserve event listeners
      container.parentNode.insertBefore(cancelButton, container.nextSibling);
    }

    // ChurnBuster = window.ChurnBuster || {};
    // ChurnBuster.cancelAttributes = {
    //   accountId: "c5e10f7a-cd58-4a32-8416-b9e7c0c3b551",
    //   source: "awtomic",
    //   customerId: window.Awtomic.subscriptionDetails.CustomerId.replace(
    //     "gid://shopify/Customer/",
    //     ""
    //   ),
    //   subscriptionId: window.Awtomic.subscriptionDetails.SubscriptionId.replace(
    //     "gid://shopify/SubscriptionContract/",
    //     ""
    //   ),
    //   customerEmail: window.Awtomic.subscriptionDetails.Customer.Email,
    //   cancelButtonText: "Cancel Subscription",
    // };

    // var script = document.createElement("script");
    // script.type = "text/javascript";
    // script.async = true;
    // script.src =
    //   "https://proxy-assets.churnbuster.io/v4/scripts.js?v=1678742553659";
    // var insert = document.getElementsByTagName("script")[0];
    // insert.parentNode.insertBefore(script, insert);
  };

  const subscriptionRowCancelButtonClicked = (subscriptionId, button) => {
    if (confirm("Are you sure you want to cancel this subscription?")) {
      const auth = JSON.parse(localStorage.getItem("awtomicApiAuth"));
      const authToken = auth.authToken;
      const customerId = auth.customerId;
      if (!authToken || !customerId) {
        console.error(
          "You are not authenticated. Please log in to cancel your subscription."
        );
        return;
      }

      const options = {
        method: "POST",
        headers: {
          accept: "application/json",
          authorization: authToken,
        },
      };

      debugger;
      if (button) {
        button.disabled = true;
        button.textContent = "Cancelling...";
      }
    }
  };

  const addCancelButtonToSubscriptionRows = () => {
    const subscriptionRows = document.querySelectorAll(
      ".bundleapp-subscription-list-item > div:nth-child(2) > div:last-child"
    );

    subscriptionRows.forEach((row) => {
      const button = row.querySelector("button");

      if (button) {
        const clonedButton = button.cloneNode(true);
        const parentItem = row.closest(".bundleapp-subscription-list-item");

        // check if its cancelled - if so do nothing
        const cancelledSpan = parentItem.querySelector(
          ".bundleapp-subscription-list-item__subscription-not-active-status"
        );
        if (cancelledSpan) return;

        if (parentItem) {
          const subscriptionId = parentItem.getAttribute(
            "data-subscription-id"
          );
          if (subscriptionId) {
            clonedButton.setAttribute("data-subscription-id", subscriptionId);
          }
        }
        clonedButton.classList.add("awt-button-cancel");
        clonedButton.textContent = "Cancel";
        clonedButton.addEventListener("click", () => {
          const subscriptionId = clonedButton.getAttribute(
            "data-subscription-id"
          );
          subscriptionRowCancelButtonClicked(subscriptionId, clonedButton);
        });
        row.appendChild(clonedButton);
      }
    });

    const auth = JSON.parse(localStorage.getItem("awtomicApiAuth"));
    const customerId = auth.customerId;
    ChurnBuster = window.ChurnBuster || {};
    ChurnBuster.cancelAttributes = {
      accountId: "c5e10f7a-cd58-4a32-8416-b9e7c0c3b551",
      source: "awtomic",
      customerId: window.Awtomic.subscriptionList[0].CustomerId.replace(
        "gid://shopify/Customer/",
        ""
      ),
      customerEmail: window.Awtomic.subscriptionList[0].Customer.Email,
      cancelButtonSelector: ".awt-button-cancel",
    };

    var script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src =
      "https://proxy-assets.churnbuster.io/v4/scripts.js?v=1678742553659";
    var insert = document.getElementsByTagName("script")[0];
    insert.parentNode.insertBefore(script, insert);
  };

  const waitForElement = (selector, interval = 100) => {
    return new Promise((resolve) => {
      const check = () => {
        const el = document.querySelector(selector);
        if (el) {
          resolve(el);
        } else {
          setTimeout(check, interval);
        }
      };
      check();
    });
  };

  if (/\/tools\/bundle-subscriptions$/.test(window.location.pathname)) {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("subscriptionId")) {
      // Sub Detail
      // move cancel button to the top actions
      waitForElement(".bundle-button--cancel").then((button) => {
        moveCancelButtonToTopActions(button);
      });
    } else {
      // Sub List
      // Add cancel button to each subscription item
      waitForElement(
        ".bundleapp-subscription-list-item > div:nth-child(2) > div:last-child"
      ).then(() => {
        addCancelButtonToSubscriptionRows();
      });
    }
  }
})();
